import { parseParamsStr } from '../../builder-selection';
import { currentBuilderState } from '../builder.state';
import { PresetView } from '../model/preset-view.model';

import { createParamsView } from './create-params-view.function';

export function loadPreset(preset: PresetView): void {
    const state = currentBuilderState();

    const bp = parseParamsStr(preset.parameters);
    state.viewParams = createParamsView(bp);
}
